import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { getTypeBadge, getDaysUntil, getDayOfWeek } from './mesJoursFeriesHelpers';

const MONTH_NAMES = [
  'january', 'february', 'march', 'april', 'may', 'june',
  'july', 'august', 'september', 'october', 'november', 'december',
];

const MesJoursFeriesCalendarView = ({ holidays, calendar }) => {
  const { t, i18n } = useTranslation();

  if (holidays.length === 0) return null;

  const holidaysByMonth = holidays.reduce((acc, holiday) => {
    const month = new Date(holiday.date).getMonth();
    if (!acc[month]) acc[month] = [];
    acc[month].push(holiday);
    return acc;
  }, {});

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {Object.keys(holidaysByMonth)
        .sort((a, b) => a - b)
        .map((month) => (
          <Card key={month}>
            <CardHeader>
              <CardTitle className="text-base">{t(`common.months.${MONTH_NAMES[month]}`, { defaultValue: MONTH_NAMES[month] })} {calendar?.year}</CardTitle>
              <CardDescription>{t("myHolidaysComponents.monthCount", { count: holidaysByMonth[month].length })}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {holidaysByMonth[month]
                  .sort((a, b) => new Date(a.date) - new Date(b.date))
                  .map((holiday) => {
                    const isToday = getDaysUntil(holiday.date) === 0;
                    const isPast = new Date(holiday.date) < new Date();

                    return (
                      <div
                        key={holiday.id}
                        className={`flex items-start gap-2 p-2 rounded ${
                          isToday ? 'bg-green-950/20 border border-green-900/40'
                          : isPast ? 'bg-muted/50 opacity-50'
                          : 'bg-muted/50'
                        }`}
                      >
                        <div className={`flex-shrink-0 w-10 h-10 rounded flex items-center justify-center ${
                          isToday ? 'bg-green-950/40' : 'bg-muted'
                        }`}>
                          <span className={`text-sm font-bold ${isToday ? 'text-green-400' : 'text-foreground'}`}>
                            {new Date(holiday.date).getDate()}
                          </span>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium truncate">{holiday.name}</p>
                          <p className="text-xs text-muted-foreground capitalize">{getDayOfWeek(holiday.date, i18n.language)}</p>
                          <div className="mt-1">{getTypeBadge(holiday.type, t)}</div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </CardContent>
          </Card>
        ))}
    </div>
  );
};

export default MesJoursFeriesCalendarView;
